/**
 * RoleType
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import { Card } from 'react-bootstrap';
import CheckMark from 'components/media/Icon2/CheckMark.jsx';
import SearchInfo from 'components/interaction/Search/SearchInfo.jsx';
import Avatar from 'components/media/Avatar/index.jsx';
import messages from './messages.js';
import AddRoleButton from './AddRoleButton/index.jsx';
import AdminList from '../AdminList.jsx';
import useSearchableList from '../useSearchableList.js';
import AdminHeader from '../AdminHeader.jsx';
import schoolRoleParser from './SchoolRole/schoolRoleParser.js';
import { INBOX_ACTIVE } from './InboxStatus.jsx';

function RoleType(props) {
  const { search = '' } = props;
  const intl = useIntl();
  const url = 'sa/schoolroles';
  const header = (
    <thead>
      <tr>
        <th className="name"><FormattedMessage {...messages.name} /></th>
        <th className=""><FormattedMessage {...messages.users} /></th>
        <th className=""><FormattedMessage {...messages.sharedInbox} /></th>
      </tr>
    </thead>
  );
  function renderRow(item) {
    return (
      <tr key={item.id}>
        <td className="name d-flex">
          <Link to={`/admin/users/role/${item.id}`} className="d-flex">
            <Avatar src={item.avatar} bsSize="small" />
            <span className="ms-3">
              {item.displayName}
              {item.systemType && <sup title={intl.formatMessage(messages.standardRole)} className="ps-1">*</sup>}
            </span>
          </Link>
        </td>
        <td className="">{item.members.list?.length}</td>
        <td className=""><CheckMark value={Boolean(item.conversations.inbox === INBOX_ACTIVE)} /></td>
      </tr>
    );
  }

  const { items, list } = useSearchableList({ search, url, version: 2, clientSearch: true, parser: schoolRoleParser });
  return (
    <Card>
      <AdminHeader
        title={messages.role}
        control={<AddRoleButton currentRoles={list} />}
        count={list.length}
      />
      <SearchInfo className="mx-4" search={search} />
      <AdminList
        resetKey={search}
        items={items}
        list={list}
        emptyMessage={messages.noRoles}
        header={header}
        renderRow={renderRow}
      />
    </Card>
  );
}

RoleType.propTypes = {
  type: PropTypes.object,
  search: PropTypes.string,
};

export default RoleType;
